import dayjs from "dayjs";

/** Portal datetime display, e.g. `2026-05-18 12:35 PM`. */
export function formatPortalDateTime(value, fallback = "—") {
  if (value == null || value === "") return fallback;
  const d = dayjs(value);
  return d.isValid() ? d.format("YYYY-MM-DD h:mm A") : fallback;
}

export function statusClasses(status) {
  const s = String(status || "").toLowerCase();
  if (s === "paid" || s === "active" || s === "completed") return "bg-green-100 text-green-700";
  if (s === "pending" || s === "invited" || s === "draft" || s === "planning") {
    return "bg-amber-100 text-amber-700";
  }
  if (s === "on_hold" || s === "on-hold" || s === "inactive" || s === "closed" || s === "archived") {
    return "bg-slate-200 text-slate-700";
  }
  return "bg-red-100 text-red-700";
}
export const noWrap = (text) => {
  return <span className="whitespace-nowrap">{text}</span>;
};